import React, { useEffect, useMemo, useState } from 'react';
import Header from './Header';
import channelProfiles from '../channelData';
import chefConfig from '../chefConfig';
import { supabase } from '../supabase';
import useDarkMode from '../hooks/useDarkMode';
import useLanguage from '../hooks/useLanguage';

const FEATURED_CREATORS = ['미뇨끼', '한신희', '유지만 yuziman', '1분요리 뚝딱이형', '자취요리신 simple cooking', '김밀란', '어쿠스틱 드링크', "지미스테이블 Jimmy's Table"];
const CHEF_CREATORS = ['셰프호윤 Chef Hoyoon', '이태리 파브리 Italy Fabri', '강레오 걍레오', '백종원 PAIK JONG WON'];

function CreatorCard({ name, count, darkMode }) {
  const config = chefConfig[name];
  return (
    <div className={`creator-card${darkMode ? ' dark' : ''}`}>
      <img
        src={channelProfiles[name]}
        alt={config?.displayName || name}
        className="creator-card-avatar"
        onError={e => { e.target.style.display = 'none'; }}
      />
      <div className="creator-card-name">{config?.displayName || name}</div>
      <div className="creator-card-count">{count}개 레시피</div>
      {config?.slug ? (
        <a href={`/${config.slug}`} className="creator-card-btn">페이지 보기 →</a>
      ) : (
        <span className="creator-card-btn creator-card-btn--soon">Coming Soon</span>
      )}
    </div>
  );
}

export default function CreatorsPage() {
  const [darkMode] = useDarkMode();
  const [language] = useLanguage();
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    let cancelled = false;
    supabase.from('recipes').select('uploader,status').eq('language', 'kr')
      .then(({ data }) => {
        if (cancelled || !data) return;
        const c = {};
        data.forEach(r => {
          if (!r.uploader || r.status === 'hidden') return;
          c[r.uploader] = (c[r.uploader] || 0) + 1;
        });
        setCounts(c);
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const featuredList = useMemo(
    () => FEATURED_CREATORS.filter(name => channelProfiles[name]),
    []
  );
  const recommendedList = useMemo(() => {
    const featuredSet = new Set(FEATURED_CREATORS);
    const chefsWithProfile = CHEF_CREATORS.filter(name => channelProfiles[name] && !featuredSet.has(name));
    const chefSet = new Set(chefsWithProfile);
    const others = Object.keys(counts)
      .filter(name => !featuredSet.has(name) && !chefSet.has(name) && channelProfiles[name])
      .sort((a, b) => (counts[b] || 0) - (counts[a] || 0));
    return [...chefsWithProfile, ...others];
  }, [counts]);

  return (
    <div className={darkMode ? 'app dark' : 'app light'}>
      <Header />
      <main>
        <section className="section creator-list-section">
          <div className="container">
            <h2 className="section-title">{language === 'kr' ? '크리에이터' : 'Creators'}</h2>

            {loading && <div style={{ textAlign: 'center', padding: 40, opacity: 0.6 }}>불러오는 중...</div>}

            {!loading && featuredList.length > 0 && (
              <div className="creator-grid">
                {featuredList.map(name => (
                  <CreatorCard key={name} name={name} count={counts[name] || 0} darkMode={darkMode} />
                ))}
              </div>
            )}

            {!loading && recommendedList.length > 0 && (
              <>
                <h3 className="section-subtitle">{language === 'kr' ? '추천 채널' : 'Recommended Channels'}</h3>
                <div className="creator-grid">
                  {recommendedList.map(name => (
                    <CreatorCard key={name} name={name} count={counts[name] || 0} darkMode={darkMode} />
                  ))}
                </div>
              </>
            )}
          </div>
        </section>
      </main>
    </div>
  );
}
